import React, { useState, useEffect } from "react";
import {
  Modal,
  Tabs,
  Checkbox,
  Select,
  Collapse,
  Button,
  Tag,
  Radio,
  message,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import TwoTwoThreeRotation from "./TwoTwoThreeRotation";
import TwoTwoThreeCreate from "./TwoTwoThreeCreate";
import AlternateWeeks from "./AlternateWeeks";
import CustomScheduleType from "./CustomScheduleType";

const { TabPane } = Tabs;
const { Panel } = Collapse;
const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const timeOptions = [
  "Not setting a time",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
];
const responsibleOperations = ["PickUp", "DropOff"];

const getInitialTimeState = (days = []) => ({
  days,
  time: "",
  customHour: 0,
  customMinute: 0,
  showDays: false,
  showCustom: false,
  showTime: false,
  responsiblityType: "",
  selectedDay: "",
});

const ChooseTime = ({
  open,
  onClose,
  activeComboId,
  activeChildId,
  parentCombinations,
  sameScheduleForAll,
  parentCombinationsV2,
  setParentCombinationsV2,
  modified,
  onSave,
  setParentCombinations,
  couples,
}) => {
  const [parentTimeState, setParentTimeState] = useState({
    parent1: { pickup: {}, dropoff: {} },
    parent2: { pickup: {}, dropoff: {} },
  });
  const [parents, setParents] = useState([]);
  const [selectedTimes, setSelectedTimes] = useState({});
  const [targetChild, setTargetChild] = useState(null);
  const [isSameForAll, setIsSameForAll] = useState(null);
  const [responsibleityType, setResponsibleityType] = useState("");
  const [customScheduleDays, setCustomScheduleDays] = useState([]);
  const [activeDay, setActiveDay] = useState([]);
  const [weekSchedules, setWeekSchedules] = useState([]);
  const comboV2 = parentCombinationsV2.find(
    (c) => (c?.id || c?.coparent_combination_id) == activeComboId
  );
  const childV2 = comboV2.children?.find(
    (c) => (c?.child_id || c?.id) == activeChildId
  );
  let scheduleId = null;
  if (sameScheduleForAll) {
    scheduleId =
      Number(comboV2?.children?.[0]?.schedule_type_id) ||
      comboV2?.schedule_type_id;
  }
  useEffect(() => {
    console.log("parentCombinationsV2: ", parentCombinationsV2);
  }, [parentCombinationsV2]);
  const coupleData = couples?.find(
    (c) => String(c.id || c.coparent_combination_id) === String(activeComboId)
  );

  const parent1Id =
    coupleData?.parent1?.user_id || comboV2?.parent1?.user_id || null;
  const parent2Id =
    coupleData?.parent2.user_id || comboV2?.parent2.user_id || null;
  useEffect(() => {
    // Find the active combo and child
    const combo = parentCombinations.find(
      (c) => (c?.id || c?.coparent_combination_id) == activeComboId
    );
    // console.log("parentCombinations",activeComboId)
    const scheduleTypeId = combo?.scheduleType?.id ?? null;
    const scheduleType = combo?.scheduleType ?? {};

    if (!combo) return;
    // console.log("combo",{combo,sameScheduleForAll,activeChildId,activeComboId})
    const child = combo.children?.find(
      (c) => (c?.child_id || c?.id) == activeChildId
    );

    setTargetChild(child);
    // console.log("child",child)
    // Set parents as before
    const buildParent = (key, labelDefault) => ({
      id: key,
      label: combo[key]?.name || labelDefault,
      email: combo[key]?.email || "",
      colorClass: combo[key]?.color || "#000",
      // days: comboV2[key]?.days || [],
      days:
        key == "parent1"
          ? child?.parent1Days ||
            combo.parent1?.days ||
            child?.parent1?.selected_days ||
            child?.parent1?.days ||
            []
          : child?.parent2Days ||
            combo.parent2?.days ||
            child?.parent2?.selected_days ||
            child?.parent2?.days ||
            [],
      isScheduleType: child?.schedule_type_id || scheduleTypeId,
      scheduleType: child?.schedule_type_id || scheduleType,
      responsible: null,
    });

    setParents([
      buildParent("parent1", "Parent 1"),
      buildParent("parent2", "Parent 2"),
    ]);

    const getTimeBlock = (timeObj = {}) => ({
      ...getInitialTimeState(timeObj.days || []),
      time: timeObj.time || "",
      customHour: timeObj.customHour || 0,
      customMinute: timeObj.customMinute || 0,
      showDays: timeObj.showDays ?? true,
      showCustom: timeObj.showCustom ?? false,
      showTime: timeObj.showTime ?? true,
    });

    // If isSameScheduleForAll is 0, use individual child days, otherwise use the parent's days
    const parent1Days = sameScheduleForAll
      ? combo.parent1?.days
      : child?.parent1Days || combo.parent1?.days;

    const parent2Days = sameScheduleForAll
      ? combo.parent2?.days
      : child?.parent2Days || combo.parent2?.days;

    // Update the parent time state based on the selected child schedule
    const getTimeStateForChild = (child, combo) => {
      const isSameScheduleForAll = sameScheduleForAll ? 1 : 0;

      const parent1Days = sameScheduleForAll
        ? combo.parent1?.days
        : child?.parent1Days ||
          combo.parent1?.days ||
          child?.parent1?.days ||
          [];

      const parent2Days = sameScheduleForAll
        ? combo.parent2?.days
        : child?.parent2Days ||
          combo.parent2?.days ||
          child?.parent2?.days ||
          [];

      const parent1Pickup = sameScheduleForAll
        ? combo.parent1?.pickup
        : child?.parent1Pickup;

      const parent1Dropoff = sameScheduleForAll
        ? combo.parent1?.dropoff
        : child?.parent1Dropoff;

      const parent2Pickup = sameScheduleForAll
        ? combo.parent2?.pickup
        : child?.parent2Pickup;

      const parent2Dropoff = sameScheduleForAll
        ? combo.parent2?.dropoff
        : child?.parent2Dropoff;

      return {
        // parent1: {
        //   pickup: getTimeBlock({ ...parent1Pickup, days: parent1Days }),
        //   dropoff: getTimeBlock({ ...parent1Dropoff, days: parent1Days }),
        // },
        parent1: { days: parent1Days },
        parent2: { days: parent2Days },
        // parent2: {
        //   pickup: getTimeBlock({ ...parent2Pickup, days: parent2Days }),
        //   dropoff: getTimeBlock({ ...parent2Dropoff, days: parent2Days }),
        // }
      };
    };

    setParentTimeState(getTimeStateForChild(child, combo));
  }, [parentCombinationsV2, activeComboId, activeChildId, sameScheduleForAll]);

  const updateState = (parentId, type, newData) => {
    console.log("updateState", parentId, type, newData);
    setParentTimeState((prev) => {
      const updated = { ...prev[parentId][type], ...newData };
      if (type === "pickup" && newData.showDays) {
        return {
          ...prev,
          [parentId]: {
            ...prev[parentId],
            [type]: updated,
            dropoff: {
              ...prev[parentId].dropoff,
              days: newData.days || prev[parentId].pickup.days,
            },
          },
        };
      }
      return {
        ...prev,
        [parentId]: {
          ...prev[parentId],
          [type]: updated,
        },
      };
    });
  };
  const onChangeIsSameForAll = (parentId, data, e) => {
    const { checked } = e.target;

    setCustomScheduleDays((prevDays) => {
      const updatedDays = { ...prevDays };
      if (checked) {
        updatedDays[parentId] = data.days;
      } else {
        delete updatedDays[parentId];
      }
      return updatedDays;
    });

    setParentCombinationsV2((prevData) =>
      prevData.map((combo) => {
        if (combo.id !== activeComboId) return combo;

        return {
          ...combo,
          children: combo.children.map((child) => {
            if (child.id !== activeChildId) return child;

            return {
              ...child,
              [parentId]: {
                ...child[parentId],
                apply_same_time_all_days: checked ? 1 : 0,
                selected_days: checked ? data.days : [],
              },
            };
          }),
        };
      })
    );
  };

  const onChangeresponsibleOperations = (selectedParentId, day, e) => {
    const value = e.target.value; // "PickUp" or "DropOff"
    const isPickup = value === "PickUp";
    const responsibleParent = isPickup
      ? selectedParentId
      : selectedParentId === "parent1"
      ? "parent2"
      : "parent1";
    const otherParent = responsibleParent === "parent1" ? "parent2" : "parent1";
    const responsibleFor = isPickup ? "pick_up" : "drop_off";

    const daysToApply = customScheduleDays?.[responsibleParent] || [day];

    // Update local UI state
    updateState(responsibleParent, isPickup ? "pickup" : "dropoff", {
      responsiblityType: value,
      selectedDay: day,
    });

    setResponsibleityType(value);

    setParentCombinationsV2((prevData) =>
      prevData.map((combo) => {
        if (combo.id !== activeComboId) return combo;

        return {
          ...combo,
          children: combo.children.map((child) => {
            if (child.id !== activeChildId) return child;

            const time = isPickup
              ? child[selectedParentId]?.pickup_time || "08:00"
              : child[responsibleParent]?.dropoff_time || "15:00";

            const newEntry = {
              day: daysToApply,
              responsible_for: responsibleFor,
              ...(isPickup ? { pickup_time: time } : { dropoff_time: time }),
            };

            const updatedResponsibleDays = [
              ...(child[responsibleParent]?.days || []).filter(
                (entry) => entry.responsible_for !== responsibleFor
              ),
              newEntry,
            ];

            const updatedOtherDays = (child[otherParent]?.days || []).filter(
              (entry) => !daysToApply.some((d) => entry.day.includes(d))
            );

            return {
              ...child,
              [responsibleParent]: {
                ...child[responsibleParent],
                days: updatedResponsibleDays,
              },
              [otherParent]: {
                ...child[otherParent],
                days: updatedOtherDays,
              },
            };
          }),
        };
      })
    );
  };

  const handleTimeSelect = (parentId, _ignoredType, time) => {
    const isPickup = responsibleityType === "PickUp";
    const responsibleParent = isPickup
      ? parentId
      : parentId === "parent1"
      ? "parent2"
      : "parent1";
    const otherParent = responsibleParent === "parent1" ? "parent2" : "parent1";
    const responsibleFor = isPickup ? "pick_up" : "drop_off";

    const daysToApply = customScheduleDays?.[responsibleParent] || [activeDay];

    // Update local UI state
    updateState(responsibleParent, isPickup ? "pickup" : "dropoff", {
      time,
      showCustom: false,
    });

    setParentCombinationsV2((prevData) =>
      prevData.map((combo) => {
        if (combo.id !== activeComboId) return combo;

        return {
          ...combo,
          children: combo.children.map((child) => {
            if (child.id !== activeChildId) return child;

            const responsibleDays = child[responsibleParent]?.days || [];
            const otherDays = child[otherParent]?.days || [];

            const newEntry = {
              day: daysToApply,
              responsible_for: responsibleFor,
              ...(isPickup ? { pickup_time: time } : { dropoff_time: time }),
            };

            const updatedResponsibleDays = [
              ...responsibleDays.filter(
                (entry) =>
                  !daysToApply.some((d) =>
                    Array.isArray(entry.day)
                      ? entry.day.includes(d)
                      : entry.day === d
                  )
              ),
              newEntry,
            ];

            const updatedOtherDays = otherDays.filter(
              (entry) => !daysToApply.some((d) => entry.day.includes(d))
            );

            return {
              ...child,
              [responsibleParent]: {
                ...child[responsibleParent],
                days: updatedResponsibleDays,
              },
              [otherParent]: {
                ...child[otherParent],
                days: updatedOtherDays,
              },
            };
          }),
        };
      })
    );
  };

  const toggleCustomTime = (parentId, type) => {
    const current = parentTimeState[parentId]?.[type]?.showCustom ?? false;
    updateState(parentId, type, { showCustom: !current });
  };

  const setCustomTime = (parentId, type, hour, minute) => {
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
      message.warning("Please enter a valid time");
      return;
    }

    const formattedTime = `${String(hour).padStart(2, "0")}:${String(
      minute
    ).padStart(2, "0")}`;

    updateState(parentId, type, {
      time: formattedTime,
      customHour: hour,
      customMinute: minute,
      showCustom: true,
    });

    handleTimeSelect(parentId, type, formattedTime);
  };

  const transformWeekSchedules = (
    childWeekSchedules = [],
    updatedSchedules = [],
    parent1Id,
    parent2Id
  ) => {
    const result = [];

    // Flatten child schedules into array of { week_number, ... }
    const flattened = [];
    childWeekSchedules.forEach((weekObj) => {
      Object.values(weekObj).forEach((week) => {
        if (week && week.week_number) {
          flattened.push(week);
        }
      });
    });

    // Helper: merge segments by selected_days + responsible_for
    const mergeSegments = (existingSegments = [], updatedSegments = []) => {
      const merged = [...existingSegments];

      updatedSegments.forEach((upd) => {
        const idx = merged.findIndex(
          (seg) =>
            Array.isArray(seg.selected_days) &&
            Array.isArray(upd.selected_days) &&
            seg.selected_days.join(",") === upd.selected_days.join(",") &&
            seg.responsible_for === upd.responsible_for
        );

        if (idx >= 0) {
          // overwrite existing with update
          merged[idx] = { ...merged[idx], ...upd };
        } else {
          // add new
          merged.push(upd);
        }
      });

      return merged;
    };

    // Process all existing weeks
    flattened.forEach((childWeek) => {
      const updatedEntry = updatedSchedules.find((weekObj) => {
        const [, updatedWeek] = Object.entries(weekObj)[0];
        return updatedWeek?.week_number === childWeek.week_number;
      });

      if (updatedEntry) {
        const [, updatedWeek] = Object.entries(updatedEntry)[0];

        const mergedSegments = mergeSegments(
          childWeek.segments || [],
          updatedWeek.segments || []
        );

        result.push({
          ...childWeek,
          segments: mergedSegments,
          ...(childWeek.week_number === 1 && { parent1_id: parent1Id }),
          ...(childWeek.week_number === 2 && { parent2_id: parent2Id }),
        });
      } else {
        // No update → keep as is
        result.push(childWeek);
      }
    });

    return result;
  };

  const getFlatWeekSchedules = (weekSchedules) => {
    const flat = [];

    weekSchedules.forEach((weekObj) => {
      for (const key in weekObj) {
        const weekData = weekObj[key];

        if (!weekData.week_number) continue;

        const flatWeek = {
          week_number: weekData.week_number,
          segments: weekData.segments || [],
        };

        // Attach the parent1_id or parent2_id
        if (weekData.parent1_id) flatWeek.parent1_id = weekData.parent1_id;
        if (weekData.parent2_id) flatWeek.parent2_id = weekData.parent2_id;

        flat.push(flatWeek);
      }
    });

    return flat;
  };

  const handleSave = () => {
    const { parent1, parent2 } = parentTimeState;

    let isvalide =
      modified ||
      onSaveValidation(
        parentCombinationsV2,
        activeComboId,
        activeChildId,
        weekSchedules
      );

    if (!isvalide) return;

    if (modified) {
      // === UPDATE MODE ===
      setParentCombinationsV2((prev) =>
        prev.map((combo) => {
          if (
            String(combo?.id || combo?.coparent_combination_id) !==
            String(activeComboId)
          ) {
            return combo;
          }

          return {
            ...combo,
            children: combo.children.map((child) => {
              // Skip if not the active child
              if (
                String(child?.id || child?.child_id) !== String(activeChildId)
              ) {
                return child;
              }

              // --- 2-2-3 rotation (41) ---
              if (
                child.schedule_type_id == "41" &&
                weekSchedules &&
                weekSchedules.length > 0
              ) {
                let updatedWeekSchedules;

                if (
                  !child.week_schedules ||
                  child.week_schedules.length === 0
                ) {
                  // first save
                  updatedWeekSchedules = weekSchedules.map((weekObj) => {
                    const key = Object.keys(weekObj)[0];
                    return {
                      week_number: weekObj[key].week_number,
                      segments: weekObj[key].segments,
                      ...(weekObj[key].week_number === 1 && {
                        parent1_id: parent1Id,
                      }),
                      ...(weekObj[key].week_number === 2 && {
                        parent2_id: parent2Id,
                      }),
                    };
                  });
                } else {
                  // cleanup base schedules
                  const base = child.week_schedules.filter(
                    (w) => w && Object.keys(w).length > 0
                  );

                  if (base.length === 0) {
                    updatedWeekSchedules = weekSchedules.map((weekObj) => {
                      const key = Object.keys(weekObj)[0];
                      return {
                        week_number: weekObj[key].week_number,
                        segments: weekObj[key].segments,
                        ...(weekObj[key].week_number === 1 && {
                          parent1_id: parent1Id,
                        }),
                        ...(weekObj[key].week_number === 2 && {
                          parent2_id: parent2Id,
                        }),
                      };
                    });
                  } else {
                    // merge
                    updatedWeekSchedules = transformWeekSchedules(
                      base,
                      weekSchedules,
                      parent1Id,
                      parent2Id
                    );
                  }
                }

                return {
                  ...child,
                  modified: modified || undefined,
                  week_schedules: updatedWeekSchedules,
                };
              }

              // --- Alternate Weeks (40) ---
              if (child.schedule_type_id == "40") {
                let newWeeks = [];

                if (Array.isArray(child.weeks)) {
                  newWeeks = child.weeks
                    .filter((w) => w && w.week_number)
                    .map((w) => {
                      return {
                        week_number: w.week_number,
                        parent1_id:
                          w.parent1_id ||
                          (w.week_number === 1 ? parent1Id : null),
                        parent2_id:
                          w.parent2_id ||
                          (w.week_number === 2 ? parent2Id : null),
                        assigned_to:
                          w.assigned_to ||
                          (w.week_number === 1 ? "parent1" : "parent2"),
                        responsible_for: w.responsible_for,
                        pickup_time: w.pickup_time,
                        dropoff_time: w.dropoff_time,
                      };
                    });
                }

                return {
                  ...child,
                  modified: modified || undefined,
                  weeks: newWeeks,
                };
              }

              // --- Custom Schedule (42) ---
              if (child.schedule_type_id == "42") {
                return {
                  ...child,
                  modified: modified || undefined,
                  parent1: {
                    ...child.parent1, // keep existing days, times etc
                    ...parent1, // merge in updated fields from state
                    parent1_id: parent1Id || null,
                    responsible_for: child.parent1?.responsible_for,
                    pickup_time:
                      parent1?.pickup_time ?? child.parent1?.pickup_time,
                    dropoff_time:
                      parent1?.dropoff_time ?? child.parent1?.dropoff_time,
                    days: child?.parent1?.days || [],
                  },
                  parent2: {
                    ...child.parent2,
                    ...parent2,
                    parent2_id: parent2Id || null,
                    responsible_for: child.parent2?.responsible_for,
                    pickup_time:
                      parent1?.pickup_time ?? child.parent2?.pickup_time,
                    dropoff_time:
                      parent2?.dropoff_time ?? child.parent2?.dropoff_time,
                    days: child?.parent2?.days || [],
                  },
                };
              }

              // fallback → return untouched child
              return child;
            }),
          };
        })
      );
    } else {
      // === CREATE MODE ===
      setParentCombinationsV2((prev) =>
        prev.map((combo) => {
          if (
            String(combo?.id || combo?.coparent_combination_id) !==
            String(activeComboId)
          ) {
            return combo;
          }

          return {
            ...combo,
            children: combo.children.map((child, index) => {
              if (sameScheduleForAll && index !== 0) return child;

              // --- 2-2-3 rotation (41) ---
              if (
                (child?.scheduleType?.id == "41" ||
                  combo?.scheduleType?.id == "41") &&
                weekSchedules &&
                weekSchedules.length > 0
              ) {
                const flattened = getFlatWeekSchedules(weekSchedules);
                if (sameScheduleForAll) {
                  return {
                    ...child,
                    week_schedules: flattened,
                  };
                }

                // Case: not same for all -> update only targetChild
                if (
                  !sameScheduleForAll &&
                  String(child?.id || child?.child_id) === String(activeChildId)
                ) {
                  return {
                    ...child,
                    week_schedules: flattened,
                  };
                }
              }

              // --- Alternate Weeks (40) ---
              if (
                child?.scheduleType?.id == "40" ||
                combo?.scheduleType?.id == "40"
              ) {
                return {
                  ...child,
                };
              }

              // --- Custom Schedule (42) ---
              if (
                child?.scheduleType?.id == "42" ||
                combo?.scheduleType?.id == "42"
              ) {
                return {
                  ...child,
                };
              }

              // fallback → untouched
              return child;
            }),
          };
        })
      );
    }

    const activeCombo = parentCombinationsV2.find(
      (c) => String(c.id || c.coparent_combination_id) === String(activeComboId)
    );
    const sameScheduleForAll =
      activeCombo?.sameScheduleForAll ||
      activeCombo?.apply_same_settings_for_children;

    if (sameScheduleForAll) {
      const relatedCombos = parentCombinationsV2.filter(
        (c) => c.childId === activeChildId || activeChildId === null
      );

      const payload = relatedCombos.map((combo) => ({
        comboId: combo.id,
        parent1,
        parent2,
      }));
      onSave(payload);
    } else {
      const data = {
        comboId: activeComboId,
        childId: activeChildId,
        parent1,
        parent2,
      };
      // onSave(data);
    }

    onClose();
  };

  const onSaveValidation = (
    parentCombinationsV2,
    activeComboId,
    activeChildId,
    weekSchedules
  ) => {
    // Find the active combo and child
    const combo = parentCombinationsV2.find(
      (c) => (c?.id || c?.coparent_combination_id) == activeComboId
    );
    if (!combo) {
      message.error("Parent combination not found.");
      console.log("Parent combination not found for ID:", activeComboId);
      return false;
    }
    let child = null;
    if (!combo.sameScheduleForAll) {
      child = combo.children?.find(
        (c) => (c?.child_id || c?.id) == activeChildId
      );
    } else {
      child = combo.children?.[0]; // For sameScheduleForAll, use the first child
    }
    if (!child) {
      message.error("Child not found.");
      console.log("Child not found for ID:", activeChildId);
      return false;
    }
    // console.log("Validating child:", child);
    // Only validate for 2-2-3 rotation
    if ((child?.scheduleType?.id || combo?.scheduleType?.id) == "40") {
      // console.log("Validating week schedules for Alternate weeks:", child.weeks);
      if (!Array.isArray(child.weeks) || child.weeks.length !== 2) {
        message.error("You must set times for both weeks (Week 1 and Week 2).");
        console.log("Invalid child.weeks:", child.weeks);
        return false;
      }

      for (let i = 0; i < child.weeks.length; i++) {
        const week = child.weeks[i];
        // Check required keys
        const requiredKeys = ["week_number", "assigned_to", "responsible_for"];
        for (const key of requiredKeys) {
          if (!(key in week)) {
            message.error(`Missing "${key}" in week ${i + 1}.`);
            console.log(`Missing "${key}" in week ${i + 1}.`);
            return false;
          }
        }
        // Check parent id
        if (week.week_number === 1 && !week.parent1_id) {
          message.error("Week 1 must have parent1_id.");
          console.log("Week 1 must have parent1_id.");
          return false;
        }
        // if (week.week_number === 2 && !week.parent2_id) {
        //   message.error("Week 2 must have parent2_id.");
        //   console.log("Week 2 must have parent2_id.");
        //   return false;
        // }
        // Check time fields
        if (week.responsible_for === "pick_up" && !week.pickup_time) {
          message.error(
            `Week ${week.week_number}: Pickup time is required for pick up.`
          );
          console.log(
            `Week ${week.week_number}: Pickup time is required for pick up.`
          );
          return false;
        }
        if (week.responsible_for === "drop_off" && !week.dropoff_time) {
          message.error(
            `Week ${week.week_number}: Dropoff time is required for drop off.`
          );
          console.log(
            `Week ${week.week_number}: Dropoff time is required for drop off.`
          );
          return false;
        }
      }
    }
    if ((child?.scheduleType?.id || combo?.scheduleType?.id) == "41") {
      // const updatedWeekSchedules = transformWeekSchedules(child.week_schedules, weekSchedules);
      const updatedWeekSchedules = getFlatWeekSchedules(weekSchedules);
      console.log(
        "Validating week schedules for 2-2-3 rotation:",
        updatedWeekSchedules
      );
      if (
        !Array.isArray(updatedWeekSchedules) ||
        updatedWeekSchedules.length === 0
      ) {
        message.error("You must set times for at least one week schedule.");
        console.log("Invalid updatedWeekSchedules:", updatedWeekSchedules);
        return false;
      }

      for (const week of updatedWeekSchedules) {
        // Check required keys
        console.log("Validating week:", week);
        if (
          !Array.isArray(week.segments) ||
          week.segments.length === 0 ||
          week.segments.length != 3
        ) {
          message.error(
            "Each week schedule must have a responsible person and time assigned for all selected days."
          );
          console.log(
            "Each week schedule must have a responsible person and time assigned for all selected days."
          );
          return false;
        }
        for (const segment of week.segments) {
          if (!segment.selected_days || segment.selected_days.length === 0) {
            message.error("Each segment must have selected days.");
            console.log("Each segment must have selected days.");
            return false;
          }
          if (!segment.assigned_to || !segment.responsible_for) {
            message.error(
              "Each segment must have assigned_to and responsible_for fields."
            );
            console.log(
              "Each segment must have assigned_to and responsible_for fields."
            );
            return false;
          }
          if (segment.responsible_for === "pick_up" && !segment.pickup_time) {
            message.error("Pickup time is required for pick up segments.");
            console.log("Pickup time is required for pick up segments.");
            return false;
          }
          if (segment.responsible_for === "drop_off" && !segment.dropoff_time) {
            message.error("Dropoff time is required for drop off segments.");
            console.log("Dropoff time is required for drop off segments.");
            return false;
          }
        }
      }
    }
    if ((child?.scheduleType?.id || combo?.scheduleType?.id) == "42") {
      // Custom schedule validation
      const parent1Data = child.parent1 || {};
      const parent2Data = child.parent2 || {};
      const parent1Days = parent1Data.days || [];
      const parent2Days = parent2Data.days || [];
      const parent1DaysList = child.parent1Days || [];
      const parent2DaysList = child.parent2Days || [];
      // 1. Both parents must have at least one day assigned
      if (
        (!parent1Data.apply_same_time_all_days && parent1Days.length === 0) ||
        (!parent2Data.apply_same_time_all_days && parent2Days.length === 0)
      ) {
        message.error("Both parents must have at least one day assigned.");
        return false;
      }

      // 2. Check that all days in parent1DaysList are present in parent1.days
      if (!parent1Data.apply_same_time_all_days) {
        for (const day of parent1DaysList) {
          const found = parent1Days.some((d) =>
            Array.isArray(d.day) ? d.day.includes(day) : d.day === day
          );
          if (!found) {
            message.error(`Day "${day}" is missing in Parent 1's days.`);
            return false;
          }
        }
      }

      // 3. Check that all days in parent2DaysList are present in parent2.days
      if (!parent2Data.apply_same_time_all_days) {
        for (const day of parent2DaysList) {
          const found = parent2Days.some((d) =>
            Array.isArray(d.day) ? d.day.includes(day) : d.day === day
          );
          if (!found) {
            message.error(`Day "${day}" is missing in Parent 2's days.`);
            return false;
          }
        }
      }
      // 4. Validate all days for parent1
      if (!parent1Data.apply_same_time_all_days) {
        for (const entry of parent1Days) {
          const days = Array.isArray(entry.day) ? entry.day : [entry.day];
          for (const day of days) {
            if (
              entry.responsible_for !== "pick_up" &&
              entry.responsible_for !== "drop_off"
            ) {
              message.error(
                `Invalid responsible_for value for Parent 1 on ${day}.`
              );
              return false;
            }
            if (entry.responsible_for === "pick_up" && !entry.pickup_time) {
              message.error(`Parent 1 must set a pickup time for ${day}.`);
              return false;
            }
            if (entry.responsible_for === "drop_off" && !entry.dropoff_time) {
              message.error(`Parent 1 must set a dropoff time for ${day}.`);
              return false;
            }
          }
        }
      }
      // 5. Validate all days for parent2
      if (!parent2Data.apply_same_time_all_days) {
        for (const entry of parent2Days) {
          const days = Array.isArray(entry.day) ? entry.day : [entry.day];
          for (const day of days) {
            if (
              entry.responsible_for !== "pick_up" &&
              entry.responsible_for !== "drop_off"
            ) {
              message.error(
                `Invalid responsible_for value for Parent 2 on ${day}.`
              );
              return false;
            }
            if (entry.responsible_for === "pick_up" && !entry.pickup_time) {
              message.error(`Parent 2 must set a pickup time for ${day}.`);
              return false;
            }
            if (entry.responsible_for === "drop_off" && !entry.dropoff_time) {
              message.error(`Parent 2 must set a dropoff time for ${day}.`);
              return false;
            }
          }
        }
      }
    }
    // If all checks pass
    return true;
  };

  const handleDayTabChange = (parentId, day) => {
    // console.log("Tab changed:", { parentId, day });
    // Optional: if you want to update any state or trigger logic
    // setSomeState(prev => ({ ...prev, [parentId]: day }));
  };

  // Function to get the selected time based on day, responsibleityType, etc.
  // Function to get the selected time based on day, responsibleityType, etc.
  const getSelectedTimeForPickupDropoff = (
    parentCombinationsV2,
    activeComboId,
    activeChildId,
    parentId, // Can be "parent1", "parent2", or a full user ID
    type, // "pickup" or "dropoff"
    day // e.g., "Monday"
  ) => {
    const combo = parentCombinationsV2.find((c) => c.id === activeComboId);
    if (!combo) return null;

    const child = combo.children.find((c) => c.id === activeChildId);
    if (!child) return null;

    let parentKey = null;

    // If it's already "parent1" or "parent2"
    if (parentId === "parent1" || parentId === "parent2") {
      parentKey = parentId;
    } else {
      // Else match user_id
      if (combo.parent1.user_id === parentId) {
        parentKey = "parent1";
      } else if (combo.parent2.user_id === parentId) {
        parentKey = "parent2";
      }
    }

    if (!parentKey) {
      console.warn("Unable to resolve parentKey for:", parentId);
      return null;
    }

    const parentData = child[parentKey];
    if (!parentData || !Array.isArray(parentData.days)) return null;

    const isPickup = type === "pickup";
    const dayEntry =
      parentData &&
      parentData?.days &&
      parentData?.days.length &&
      parentData.days.find(
        (entry) =>
          Array.isArray(entry.day) &&
          entry.day.includes(day) &&
          entry.responsible_for === (isPickup ? "pick_up" : "drop_off")
      );

    if (!dayEntry) return null;

    return isPickup ? dayEntry.pickup_time : dayEntry.dropoff_time;
  };

  const renderTimeSection = (
    parentId,
    parentName,
    type,
    scheduleType,
    parentDays = []
  ) => {
    const label = type === "pickup" ? "Pick-up" : "Drop-off";
    const isCustomSchedule = scheduleType?.id === 42;
    const data = parentTimeState[parentId]?.[type] || {};
    const days = data?.days?.length ? data.days : parentDays;

    const toggleDaySection = () => {
      updateState(parentId, type, {
        showDays: !data.showDays,
        showTime: !data.showDays,
      });
    };

    const toggleTimeSection = () => {
      updateState(parentId, type, { showTime: !data.showTime });
    };

    const renderResponsibleSelector = () => (
      <div style={{ margin: "16px 0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <strong>Responsible for:</strong>
          <Radio.Group
            onChange={(e) =>
              onChangeresponsibleOperations(parentId, activeDay, e)
            }
            options={responsibleOperations}
          />
        </div>
      </div>
    );

    const renderTimeOptions = (data) => {
      // console.log("data>>>>", data)

      const selectedTime = getSelectedTimeForPickupDropoff(
        parentCombinationsV2,
        activeComboId,
        activeChildId,
        parentId,
        type,
        activeDay
      );

      const customTime =
        data.customHour !== undefined && data.customMinute !== undefined
          ? `${String(data.customHour).padStart(2, "0")}:${String(
              data.customMinute
            ).padStart(2, "0")}`
          : null;

      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {timeOptions.map((option) => {
            const isSelected =
              selectedTime?.trim().toLowerCase() ===
              option.trim().toLowerCase();
            return (
              <Tag.CheckableTag
                key={option}
                checked={isSelected}
                onChange={() => handleTimeSelect(parentId, type, option)}
                style={{
                  borderRadius: 8,
                  padding: "4px 12px",
                  backgroundColor: isSelected ? "#f3e8ff" : "#f6f6f6",
                  color: isSelected ? "#9A4FE0" : "#000",
                }}
              >
                {option}
              </Tag.CheckableTag>
            );
          })}
          {customTime && (
            <Tag.CheckableTag
              key="custom"
              checked={selectedTime === customTime}
              onChange={() => handleTimeSelect(parentId, type, customTime)}
              style={{
                borderRadius: 8,
                padding: "4px 12px",
                backgroundColor:
                  selectedTime === customTime ? "#f3e8ff" : "#f6f6f6",
                color: selectedTime === customTime ? "#9A4FE0" : "#000",
              }}
            >
              {customTime}
            </Tag.CheckableTag>
          )}
          <Button
            type={data.showCustom ? "primary" : "dashed"}
            onClick={() => toggleCustomTime(parentId, type)}
          >
            Customize...
          </Button>
        </div>
      );
    };

    const renderCustomTimeInputs = (data) => {
      if (!data?.showCustom) return null;

      const hours = Array.from({ length: 24 }, (_, i) => i);
      const minutes = Array.from({ length: 60 }, (_, i) => i);

      const isSaveDisabled =
        data.customHour === undefined || data.customMinute === undefined;

      return (
        <div
          style={{
            marginTop: 16,
            display: "flex",
            gap: 8,
            alignItems: "center",
          }}
        >
          <Select
            placeholder="HH"
            value={data.customHour}
            onChange={(val) => updateState(parentId, type, { customHour: val })}
            style={{ width: 80 }}
          >
            {hours.map((h) => (
              <Select.Option key={h} value={h}>
                {String(h).padStart(2, "0")}
              </Select.Option>
            ))}
          </Select>
          <span>:</span>
          <Select
            placeholder="MM"
            value={data.customMinute}
            onChange={(val) =>
              updateState(parentId, type, { customMinute: val })
            }
            style={{ width: 80 }}
          >
            {minutes.map((m) => (
              <Select.Option key={m} value={m}>
                {String(m).padStart(2, "0")}
              </Select.Option>
            ))}
          </Select>
          <Button
            type="primary"
            disabled={isSaveDisabled}
            onClick={() =>
              setCustomTime(parentId, type, data.customHour, data.customMinute)
            }
          >
            Save
          </Button>
        </div>
      );
    };

    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 30,
            gap: 20,
          }}
        >
          <strong>{parentName} Days</strong>
          <div
            onClick={isCustomSchedule ? toggleDaySection : toggleTimeSection}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: "15px 30px",
              flex: 1,
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {isCustomSchedule ? (
              <span>{days.length ? days.join(", ") : "Select days"}</span>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: scheduleType?.label || "Select Pickup/Dropoff Time",
                }}
              />
            )}
            <DownOutlined
              style={{
                transform: (isCustomSchedule ? data.showDays : data.showTime)
                  ? "rotate(0deg)"
                  : "rotate(-90deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontWeight: 600 }}>Same for all days</span>
          <Checkbox
            value={isSameForAll}
            onChange={(e) => onChangeIsSameForAll(parentId, data, e)}
          />
        </div>

        {isCustomSchedule && data.showDays && (
          <>
            {/* ✅ If "Same for all days" is checked */}
            {customScheduleDays[parentId] ? (
              <div className="custom-same-for-all-section">
                {/* Only show one responsibility selector */}
                {renderResponsibleSelector()}

                {/* Render one time section for all days */}
                {responsibleityType === "PickUp" && (
                  <>
                    <div style={{ fontWeight: 500, marginBottom: 8 }}>
                      Pickup Time
                    </div>
                    {renderTimeOptions(parentTimeState[parentId]?.pickup || {})}
                    {renderCustomTimeInputs(
                      parentTimeState[parentId]?.pickup || {}
                    )}
                  </>
                )}

                {responsibleityType === "DropOff" && (
                  <>
                    <div style={{ fontWeight: 500, marginBottom: 8 }}>
                      Dropoff Time
                    </div>
                    {renderTimeOptions(
                      parentTimeState[parentId]?.dropoff || {}
                    )}
                    {renderCustomTimeInputs(
                      parentTimeState[parentId]?.dropoff || {}
                    )}
                  </>
                )}

                {/* Optionally, list all affected days for clarity */}
                <div style={{ marginTop: 12 }}>
                  <strong>Applied to days:</strong>{" "}
                  {customScheduleDays[parentId].join(", ")}
                </div>
              </div>
            ) : (
              // Fallback to tab UI for individual day customization
              <Tabs
                className="daysnew"
                type="card"
                activeKey={activeDay}
                onChange={(key) => {
                  setActiveDay(key);
                  handleDayTabChange(parentId, key);
                }}
              >
                {days.map((day) => {
                  const pickupData = parentTimeState[
                    parentId
                  ]?.pickup?.days.includes(day)
                    ? parentTimeState[parentId].pickup
                    : {};
                  const dropoffData = parentTimeState[
                    parentId
                  ]?.dropoff?.days.includes(day)
                    ? parentTimeState[parentId].dropoff
                    : {};

                  return (
                    <TabPane tab={day} key={day} className="testnew">
                      {renderResponsibleSelector()}
                      {responsibleityType === "PickUp" && (
                        <>
                          <div style={{ fontWeight: 500, marginBottom: 8 }}>
                            Pickup Time
                          </div>
                          {renderTimeOptions(pickupData)}
                          {renderCustomTimeInputs(pickupData)}
                        </>
                      )}
                      {responsibleityType === "DropOff" && (
                        <>
                          <div style={{ fontWeight: 500, marginBottom: 8 }}>
                            Dropoff Time
                          </div>
                          {renderTimeOptions(dropoffData)}
                          {renderCustomTimeInputs(dropoffData)}
                        </>
                      )}
                    </TabPane>
                  );
                })}
              </Tabs>
            )}
          </>
        )}

        {!isCustomSchedule && data.showTime && (
          <>
            {renderResponsibleSelector()}
            {renderTimeOptions(data)}
            {renderCustomTimeInputs(data)}
          </>
        )}
      </div>
    );
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      maskClosable={false}
      footer={null}
      centered
      width={800}
      title={
        sameScheduleForAll
          ? "Choose Time for All Children"
          : `Choose Time for ${targetChild?.name || targetChild?.child_name}`
      }
    >
      <div style={{ margin: "30px 0 24px" }}>
        {parents.map((parent, index) => {
          const { id, label, colorClass, isScheduleType, scheduleType, days } =
            parent;
          if (isScheduleType == 42 || scheduleId == 42) {
            return (
              <React.Fragment key={id}>
                {index === 0 && (
                  <div style={{ fontWeight: 600, marginBottom: 10 }}>
                    Custom Schedule
                  </div>
                )}
                <Collapse
                  defaultActiveKey={["1"]}
                  accordion
                  expandIcon={({ isActive }) => (
                    <DownOutlined
                      style={{ color: "#9A4FE0" }}
                      rotate={isActive ? 0 : 270}
                    />
                  )}
                  expandIconPosition="end"
                  bordered={false}
                  style={{ marginBottom: 30 }}
                >
                  <Panel
                    key={id}
                    header={
                      <div
                        style={{
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontWeight: 400 }}>{label}</span>
                        <span
                          style={{
                            marginLeft: 6,
                            backgroundColor: colorClass?.value,
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                    }
                  >
                    <div style={{ paddingLeft: 20, marginTop: 20 }}>
                      <CustomScheduleType
                        activeComboId={activeComboId}
                        activeChildId={activeChildId}
                        days={days}
                        parentId={id}
                        setParentCombinationsV2={setParentCombinationsV2}
                        parentCombinationsV2={parentCombinationsV2}
                        scheduleType={scheduleType}
                        parentTimeState={parentTimeState}
                        modified={modified}
                        parentCombinations={parentCombinations}
                        setParentCombinations={setParentCombinations}
                        sameScheduleForAll={sameScheduleForAll}
                      />
                      {/* {renderTimeSection(id, label, "pickup", scheduleType, days)} */}
                    </div>
                  </Panel>
                </Collapse>
              </React.Fragment>
            );
          }
          if (isScheduleType == 41 || scheduleId == 41) {
            return (
              <React.Fragment key={id}>
                {index === 0 && (
                  <div style={{ fontWeight: 600, marginBottom: 10 }}>
                    2-2-3 Rotation Setup
                  </div>
                )}
                <Collapse
                  defaultActiveKey={["1"]}
                  accordion
                  destroyOnHidden={false}
                  expandIcon={({ isActive }) => (
                    <DownOutlined
                      style={{ color: "#9A4FE0" }}
                      rotate={isActive ? 0 : 270}
                    />
                  )}
                  expandIconPosition="end"
                  bordered={false}
                  style={{ marginBottom: 30 }}
                >
                  <Panel
                    key={id}
                    header={
                      <div
                        style={{
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontWeight: 400 }}>
                          {index === 0 ? "Week 1 Days" : "Week 2 Days"}
                        </span>
                        {/* <span
                          style={{
                            marginLeft: 6,
                            backgroundColor: colorClass?.value,
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                          }}
                        /> */}
                      </div>
                    }
                  >
                    <div style={{ paddingLeft: 20, marginTop: 20 }}>
                      {modified ? (
                        <TwoTwoThreeRotation
                          weekSchedules={weekSchedules}
                          setWeekSchedules={setWeekSchedules}
                          parentId={id}
                          parents={parents}
                          index={index}
                          parentCombinations={parentCombinations}
                          parentCombinationsV2={parentCombinationsV2}
                          activeComboId={activeComboId}
                          activeChildId={activeChildId}
                          setParentCombinationsV2={setParentCombinationsV2}
                          modified={modified}
                          couples={couples}
                          sameScheduleForAll={
                            sameScheduleForAll ||
                            comboV2?.apply_same_settings_for_children ||
                            comboV2?.isSameScheduleForAll ||
                            comboV2?.sameScheduleForAll
                          }
                        />
                      ) : (
                        <TwoTwoThreeCreate
                          weekSchedules={weekSchedules}
                          setWeekSchedules={setWeekSchedules}
                          parentId={id}
                          parents={parents}
                          index={index}
                          parentCombinations={parentCombinations}
                          parentCombinationsV2={parentCombinationsV2}
                          activeComboId={activeComboId}
                          activeChildId={activeChildId}
                          setParentCombinationsV2={setParentCombinationsV2}
                          modified={modified}
                          sameScheduleForAll={
                            sameScheduleForAll ||
                            comboV2?.apply_same_settings_for_children ||
                            comboV2?.isSameScheduleForAll ||
                            comboV2?.sameScheduleForAll
                          }
                        />
                      )}
                    </div>
                  </Panel>
                </Collapse>
              </React.Fragment>
            );
          }
          if (isScheduleType == 40 || scheduleId == 40) {
            return (
              <React.Fragment key={id}>
                {index === 0 && (
                  <div style={{ fontWeight: 600, marginBottom: 10 }}>
                    Alternate Weeks
                  </div>
                )}
                <Collapse
                  defaultActiveKey={["1"]}
                  accordion
                  expandIcon={({ isActive }) => (
                    <DownOutlined
                      style={{ color: "#9A4FE0" }}
                      rotate={isActive ? 0 : 270}
                    />
                  )}
                  expandIconPosition="end"
                  bordered={false}
                  style={{ marginBottom: 30 }}
                >
                  <Panel
                    key={id}
                    header={
                      <div
                        style={{
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontWeight: 400 }}>
                          {label} {index === 0 ? "Week 1" : "Week 2"}
                        </span>
                        <span
                          style={{
                            marginLeft: 6,
                            backgroundColor: colorClass?.value,
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                    }
                  >
                    <div style={{ paddingLeft: 20, marginTop: 20 }}>
                      <AlternateWeeks
                        parentId={id}
                        sameScheduleForAll={sameScheduleForAll}
                        modified={modified}
                        parents={parents}
                        index={index}
                        parentCombinations={parentCombinations}
                        parentCombinationsV2={parentCombinationsV2}
                        activeComboId={activeComboId}
                        activeChildId={activeChildId}
                        setParentCombinationsV2={setParentCombinationsV2}
                      />
                    </div>
                  </Panel>
                </Collapse>
              </React.Fragment>
            );
          }
          return null;
        })}
      </div>

      <div style={{ textAlign: "center" }}>
        <Button type="primary" size="large" onClick={handleSave}>
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default ChooseTime;
